import { useEffect, useState } from "react";
import { CUSTOMER_LEVEL_TABLE, REBALANCING_TABLE } from "../../utils/dataconstants";
import { Button, Modal, Table } from "rsuite";
import { useGetForecastCustomerLevelData } from "../../services/redux/hooks/useForecast";
import { useSelector } from "react-redux";
import { IRoot } from "../../services/interface/IHome";
import { useForecastRebalancingData } from "../../services/redux/hooks/useInventory";
import { formatNumber } from "../../utils/formatter";

const { Cell, HeaderCell, Column } = Table;

const RebalancingTable = (props: any) => {
    const { SKUl } = props;
    const isHeightHidden = true;
    const [loading, setLoading] = useState<boolean>(false);
    const [customerTableData, setCustomerTableData] = useState([]);
    const windowSize = useSelector((state: IRoot) => state.filter.windowSize);
    const { mutate, isSuccess, isLoading, data: customerData } = useForecastRebalancingData();

    // Custom data
    const customDataMap: any = {
        "861582403U": [
            {
                "Material": "861582403U",
                "Plant": "DC 3",
                "SKUl": "861582403U_DC 3",
                "ReBalancePlant": "DC 1",
                "Future_ABC_Segmentation_RB": "AA. FAST-LV",
                "Onhand_RB": 59324,
                "OnhandDollarValue_RB": 77121,
                "AvgMonthlyDemandLast6M_RB": 111233,
                "DOH_RB": 16,
                "Plant_Code": "District 1",
                "Service_Center_Cluster_Name": "Minneapolis Svc Center",
                "DOHAfterTransfer": 65
            },
            {
                "Material": "861582403U",
                "Plant": "DC 3",
                "SKUl": "861582403U_DC 3",
                "ReBalancePlant": "DC 2",
                "Future_ABC_Segmentation_RB": "0A. FAST-LV",
                "Onhand_RB": 56775,
                "OnhandDollarValue_RB": 91408,
                "AvgMonthlyDemandLast6M_RB": 85163,
                "DOH_RB": 20,
                "Plant_Code": "District 2",
                "Service_Center_Cluster_Name": "Youngstown Svc Center",
                "DOHAfterTransfer": 84
            },
            {
                "Material": "861582403U",
                "Plant": "DC 3",
                "SKUl": "861582403U_DC 3",
                "ReBalancePlant": "DC 8",
                "Future_ABC_Segmentation_RB": "3D. SLOW-HC",
                "Onhand_RB": 132131,
                "OnhandDollarValue_RB": 183662,
                "AvgMonthlyDemandLast6M_RB": 99098,
                "DOH_RB": 40,
                "Plant_Code": "District 2",
                "Service_Center_Cluster_Name": "Youngstown Svc Center",
                "DOHAfterTransfer": 95
            },
            {
                "Material": "861582403U",
                "Plant": "DC 3",
                "SKUl": "861582403U_DC 3",
                "ReBalancePlant": "DC 5",
                "Future_ABC_Segmentation_RB": "X1. X1",
                "Onhand_RB": 239000,
                "OnhandDollarValue_RB": 59272,
                "AvgMonthlyDemandLast6M_RB": 0,
                "DOH_RB": null,
                "Plant_Code": "District 3",
                "Service_Center_Cluster_Name": "Cinncinati Svc Center",
                "DOHAfterTransfer": null
            }
        ],
        "802411574U": [
            {
                "Material": "802411574U",
                "Plant": "DC 2",
                "SKUl": "802411574U_DC 2",
                "ReBalancePlant": "DC 5",
                "Future_ABC_Segmentation_RB": "3D. SLOW-HC",
                "Onhand_RB": 11207,
                "OnhandDollarValue_RB": 39224,
                "AvgMonthlyDemandLast6M_RB": 25862,
                "DOH_RB": 13,
                "Plant_Code": "District 1",
                "Service_Center_Cluster_Name": "Minneapolis Svc Center",
                "DOHAfterTransfer": 42
            },
            {
                "Material": "802411574U",
                "Plant": "DC 2",
                "SKUl": "802411574U_DC 2",
                "ReBalancePlant": "DC 5",
                "Future_ABC_Segmentation_RB": "2C. FAST-HV",
                "Onhand_RB": 22500,
                "OnhandDollarValue_RB": 105750,
                "AvgMonthlyDemandLast6M_RB": 25000,
                "DOH_RB": 27,
                "Plant_Code": "District 3",
                "Service_Center_Cluster_Name": "Cinncinati Svc Center",
                "DOHAfterTransfer": 57
            },
            {
                "Material": "802411574U",
                "Plant": "DC 2",
                "SKUl": "802411574U_DC 2",
                "ReBalancePlant": "DC 1",
                "Future_ABC_Segmentation_RB": "1B. SLOW-LV",
                "Onhand_RB": 30303,
                "OnhandDollarValue_RB": 154545,
                "AvgMonthlyDemandLast6M_RB": 22727,
                "DOH_RB": 40,
                "Plant_Code": "District 2",
                "Service_Center_Cluster_Name": "Youngstown Svc Center",
                "DOHAfterTransfer": 73
            },
            {
                "Material": "802411574U",
                "Plant": "DC 2",
                "SKUl": "802411574U_DC 2",
                "ReBalancePlant": "DC 8",
                "Future_ABC_Segmentation_RB": "2D. SLOW-HV",
                "Onhand_RB": 12891,
                "OnhandDollarValue_RB": 37770,
                "AvgMonthlyDemandLast6M_RB": 11719,
                "DOH_RB": 33,
                "Plant_Code": "District 2",
                "Service_Center_Cluster_Name": "Youngstown Svc Center",
                "DOHAfterTransfer": 97
            }
        ],
        "885858794U": [
            {
                "Material": "885858794U",
                "Plant": "DC 14",
                "SKUl": "885858794U_DC 14",
                "ReBalancePlant": "DC 4",
                "Future_ABC_Segmentation_RB": "1D. SLOW-HM-LLT",
                "Onhand_RB": 98107,
                "OnhandDollarValue_RB": 81429,
                "AvgMonthlyDemandLast6M_RB": 71786,
                "DOH_RB": 41,
                "Plant_Code": "District 3",
                "Service_Center_Cluster_Name": "Cinncinati Svc Center",
                "DOHAfterTransfer": 69
            }
        ]
    };

    useEffect(() => {
        // Check if this is one of the specific item IDs we want to override
        if (customDataMap[SKUl]) {
            setCustomerTableData(customDataMap[SKUl]);
            setLoading(false);
            return; // Don't make API call for these specific items
        }

        // Make API call for other items
        mutate({
            "Material": SKUl
        });
    }, [SKUl]);

    useEffect(() => {
        // Only process API data if it's not one of the custom items
        if (!customDataMap[SKUl]) {
            setLoading(true);
            if (customerData) {
                setCustomerTableData(customerData?.data);
                if (isSuccess)
                    setLoading(false);
            }
        }
    }, [customerData, SKUl]);

    const CustomCell = ({ rowData, dataKey, ...props }: any) => {
        if (dataKey === "OnhandDollarValue_RB") {
            return (
                <Cell {...props} className="table-cell-title font-normal">
                    ${formatNumber(rowData[dataKey])}
                </Cell>
            );
        }

        // Handle null values
        if (rowData[dataKey] === null || rowData[dataKey] === undefined) {
            return (
                <Cell {...props} className="table-cell-title font-normal">
                    -
                </Cell>
            );
        }

        return (
            <Cell {...props} className="table-cell-title font-normal">
                {formatNumber(rowData[dataKey])}
            </Cell>
        );
    };

    return (
        <>
            <Table
                loading={loading}
                bordered
                height={235}
                shouldUpdateScroll={false}
                data={loading ? [] : customerTableData}
                headerHeight={60}
                cellBordered
                rowClassName={(rowData, rowIndex) => {
                    return rowIndex % 2 === 0 ? 'db-tablebg' : '';
                }}
            >
                {REBALANCING_TABLE.map((value, index) => {
                    const width = 120;
                    return (
                        <Column key={value.key} width={width}>
                            <HeaderCell 
                                style={{ textWrap: "wrap" }} 
                                className="table-header-title font-semibold"
                            >
                                {value.label}
                            </HeaderCell>
                            <CustomCell dataKey={value.key} />
                        </Column>
                    );
                })}
            </Table>
        </>
    );
};

export default RebalancingTable;